<script>
import LogoApp from "@/components/logo.vue"

export default {
  name: 'FooterApp',
  components: { LogoApp }
}
</script>

<template>
  <footer class="p-4 bg-primary-700 sm:p-6 text-white dark:bg-gray-800">
    <div class="mx-auto max-w-screen-xl">
      <div class="md:flex md:justify-between">
        <div class="mb-6 md:mb-0">
          <LogoApp color="text-white" />
        </div>
        <div class="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-3">
          <div>
            <h2 class="mb-6 text-sm font-semibold uppercase">Magasin</h2>
            <ul class="text-gray-600 dark:text-gray-400">
              <li class="mb-4">
                <router-link to="/boutique" class="hover:underline">Nos produits</router-link>
              </li>
            </ul>
          </div>
          <div>
            <h2 class="mb-6 text-sm font-semibold uppercase">A propos de nous</h2>
            <ul class="text-gray-600 dark:text-gray-400">
              <li class="mb-4">
                <router-link to="/a-propos" class="text-white hover:underline ">
                  Qui nous sommes ?
                </router-link>
              </li>
              <li>
                <router-link to="/contact" class="text-white">Contact</router-link>
              </li>
            </ul>
          </div>
          <div>
            <h2 class="mb-6 text-sm font-semibold uppercase">Legal</h2>
            <ul class="text-gray-600 dark:text-gray-400">
              <li class="mb-4">
                <a href="#" class="hover:underline text-white">Privacy Policy</a>
              </li>
              <li>
                <a href="#" class="hover:underline text-white">Terms &amp; Conditions</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
      <div class="sm:flex sm:items-center sm:justify-between">
            <span class="text-sm text-gray-500 sm:text-center dark:text-gray-400">
              © 2024 <router-link to="/" class="hover:underline">Déglingo</router-link>. Tous droits réservés.
              Développé par
              <a href="https://matteo-bonneval.fr" class="hover:underline" target="_blank">Mattéo Bonneval</a>
            </span>
        <div class="flex mt-4 space-x-6 sm:justify-center sm:mt-0">
          <a href="https://gitlab.com/matteobnvl" target="_blank" class="text-gray-500 hover:text-gray-900 dark:hover:text-white">
            <i class="fa-brands fa-gitlab"></i>
          </a>
          <a href="https://www.instagram.com/matteo_bnvl/" target="_blank" class="text-gray-500 hover:text-gray-900 dark:hover:text-white">
            <i class="fa-brands fa-instagram"></i>
          </a>
          <a href="https://matteo-bonneval.fr" target="_blank" class="text-gray-500 hover:text-gray-900 dark:hover:text-white">
            <i class="fa-solid fa-globe"></i>
          </a>
          <a href="https://www.linkedin.com/in/matteo-bonneval-04080022a/" target="_blank" class="text-gray-500 hover:text-gray-900 dark:hover:text-white">
            <i class="fa-brands fa-linkedin"></i>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>
